module.exports = "/assets/about/success/fba2021.png?61LJypK";